// La bandeja de subidas viva y su ventana, UNA vez por página (Entrega 3). Antes la pedía y la pintaba la sección de la
// lista: en el móvil, con un chat abierto, la lista no está y «Revisar la subida» no tenía ventana que abrir. Ahora la
// mantiene viva la página (cada 30 s y al volver) y la ventana se abre desde donde sea (store.ts `abrirSubida`).
import { useEffect } from 'react';
import { despliegueAbierto } from './BandejaDespliegues';
import { useBandejaStore, useBandejaViva } from './store';
import { VentanaDespliegue } from './VentanaDespliegue';

export function SubidasVivas() {
  useBandejaViva();
  const pendientes = useBandejaStore((s) => s.bandeja?.pendientes);
  const abierta = useBandejaStore((s) => s.abierta);
  const abrirSubida = useBandejaStore((s) => s.abrirSubida);
  const d = despliegueAbierto(pendientes ?? [], abierta);
  // Ya no está pendiente (aprobada, rechazada, cambió en GitHub): la ventana se cierra sola.
  useEffect(() => {
    if (abierta !== null && pendientes && !d) abrirSubida(null);
  }, [abierta, pendientes, d, abrirSubida]);
  return <VentanaDespliegue despliegue={d} alCerrar={() => abrirSubida(null)} />;
}
